import { authState } from "../states/auth";
import { fetcher } from "./fetcher";

interface User {
  id: string
  displayedName:string
  avatar:string
  tarif: "FREE" | "PAY",
  isConnect:boolean
}

export async function login(token: string) {
  const res = await fetcher.post({
    path: "/auth/login",
    payload: {token}
  })
  return res
}

export async function check_login() {
  await fetcher.get({
    path: "/auth/check-login"
  })
}

export async function updateAuthedUser(fields: any) {
  const res = await fetcher.patch({
    path: `/users/${authState.id}`,
    payload: fields
  }) as User
  return res
}

export async function new_unknown() {
  const res = await fetcher.post({
    path: '/auth/unknown',
    payload: {}
  }) as User & {token: string}
  return res
}

export async function auth_recorder(creds: string, roomId: string) {
  const res = await fetcher.post({
    path: '/auth/recorder',
    payload: {
      creds,
      roomId
    }
  }) as User & {token: string}
  return res
}
